import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, FolderTree, Key, FileText, Image as ImageIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="w-10 h-10 text-gold" data-id="element-198" />,
    title: 'Guía PDF "El Family Vault Digital"',
    desc: 'El manual paso a paso con instrucciones en español claro y letras grandes.'
  }, {
    icon: <FolderTree className="w-10 h-10 text-gold" data-id="element-199" />,
    title: 'Estructura de Carpetas 01-05',
    desc: 'El mapa exacto para saber qué va en cada lugar sin confundirte.'
  }, {
    icon: <Key className="w-10 h-10 text-gold" data-id="element-200" />,
    title: 'Protocolo de Seguridad para No-Expertos',
    desc: 'Cómo dejar tus claves listas sin exponer tu privacidad a extraños.'
  }, {
    icon: <FileText className="w-10 h-10 text-gold" data-id="element-201" />,
    title: 'Checklist de Documentos de Supervivencia',
    desc: 'Los 7 archivos que debes tener digitalizados hoy mismo para cualquier emergencia.'
  }, {
    icon: <ImageIcon className="w-10 h-10 text-gold" data-id="element-202" />,
    title: 'Guía de Rescate de Fotos',
    desc: 'Cómo salvar tus recuerdos de WhatsApp y Facebook antes de que desaparezcan.'
  }];
  return <section className="bg-navy text-white py-20 px-6" data-id="element-203">
      <div className="max-w-5xl mx-auto" data-id="element-204">
        <FadeIn data-id="element-205">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-cream" data-id="element-206">
            ¿Qué incluye el sistema?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-207">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-208">
              <div className="bg-white/10 p-8 rounded-2xl border border-white/20 h-full hover:bg-white/15 transition-colors" data-id="element-209">
                <div className="bg-navy p-4 rounded-xl inline-block mb-6 shadow-lg" data-id="element-210">
                  {item.icon}
                </div>
                <h3 className="text-2xl font-bold text-cream mb-4" data-id="element-211">
                  {item.title}
                </h3>
                <p className="text-lg text-gray-300" data-id="element-212">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-213">
          <div className="text-center pt-12" data-id="element-214">
            <a href="https://dancodigital.com/cart/44413385211987:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold hover:bg-yellow-600 text-white font-bold py-4 px-10 rounded-xl shadow-xl transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl text-xl w-full md:w-auto text-center" data-id="element-215">
              ¡Obtén Todo Esto por Solo $19!
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}